module.exports = __webpack_public_path__ + "img/workflow_active.df4279a9.svg";